import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./components/auth/PrivateRoute";
import AppLayout from "./components/layout/AppLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ContractsPage from "./pages/ContractsPage";
import ContractDetailsPage from "./pages/ContractDetailsPage";
import ImportsPage from "./pages/ImportsPage";
import ImportDetailsPage from "./pages/ImportDetailsPage";
import UsersPage from "./pages/UsersPage";
import ProfilePage from "./pages/ProfilePage";
import NotFoundPage from "./pages/NotFoundPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import ScheduledImportsPage from "./pages/ScheduledImportsPage";
import PhotothequePage from "./pages/PhotothequePage";
// NOUVEAU : Import des pages comptables
import ComptabilitePage from "./pages/ComptabilitePage";
// L'ancienne page AccountingPage n'est plus utilisée dans les routes actuelles
// import AccountingPage from "./pages/AccountingPage"; // Ancien plan comptable

const AppRoutes = () => {
  return (
    <Routes>
      {/* Route publique pour la connexion */}
      <Route path="/login" element={<LoginPage />} />

      {/* Routes indépendantes du layout (Plein écran) */}
      <Route
        path="/phototheque"
        element={
          <PrivateRoute>
            <PhotothequePage />
          </PrivateRoute>
        }
      />

      {/* Utiliser le layout pour toutes les autres routes authentifiées */}
      <Route element={<AppLayout />}>
        {/* Routes privées avec le layout commun */}
        <Route
          path="/"
          element={
            <PrivateRoute requiredPermission="canViewDashboard">
              <DashboardPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/access-denied"
          element={
            <PrivateRoute>
              <AccessDeniedPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/contracts"
          element={
            <PrivateRoute>
              <ContractsPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/contracts/:id"
          element={
            <PrivateRoute>
              <ContractDetailsPage />
            </PrivateRoute>
          }
        />



        <Route
          path="/imports"
          element={
            <PrivateRoute requiredPermission="canImport">
              <ImportsPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/scheduled-imports"
          element={
            <PrivateRoute allowedRoles={["admin", "admin_assistant"]}>
              <ScheduledImportsPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/imports/:id"
          element={
            <PrivateRoute requiredPermission="canImport">
              <ImportDetailsPage />
            </PrivateRoute>
          }
        />

        {/* ========================================
             NOUVEAU : ROUTES COMPTABILITÉ 
        ======================================== */}
        
        {/* Route principale du module comptable */}
        <Route
          path="/comptabilite"
          element={
            <PrivateRoute>
              <ComptabilitePage />
            </PrivateRoute>
          }
        />

        {/* Routes spécifiques aux sous-modules (optionnelles) */}
        <Route
          path="/comptabilite/plan-comptable"
          element={
            <PrivateRoute>
              {/* Rediriger vers la nouvelle interface intégrée */}
              <Navigate to="/comptabilite?module=plan-comptable" replace />
            </PrivateRoute>
          }
        />

        <Route
          path="/comptabilite/saisie"
          element={
            <PrivateRoute>
              <Navigate to="/comptabilite?module=saisie" replace />
            </PrivateRoute>
          }
        />

        <Route
          path="/comptabilite/journaux"
          element={
            <PrivateRoute>
              <Navigate to="/comptabilite?module=journaux" replace />
            </PrivateRoute>
          }
        />

        <Route
          path="/comptabilite/balance"
          element={
            <PrivateRoute>
              <Navigate to="/comptabilite?module=balance" replace />
            </PrivateRoute>
          }
        />

        <Route
          path="/comptabilite/etats-financiers"
          element={
            <PrivateRoute>
              <Navigate to="/comptabilite?module=etats-financiers" replace />
            </PrivateRoute>
          }
        />

        <Route
          path="/comptabilite/cloture"
          element={
            <PrivateRoute allowedRoles={["admin", "admin_assistant"]}>
              <Navigate to="/comptabilite?module=cloture" replace />
            </PrivateRoute>
          }
        />

        {/* COMPATIBILITÉ : Garder l'ancienne route du plan comptable */}
        <Route
          path="/compta"
          element={
            <PrivateRoute>
              <Navigate to="/comptabilite?module=plan-comptable" replace />
            </PrivateRoute>
          }
        />

        <Route
          path="/users"
          element={
            <PrivateRoute requiredPermission="canManageUsers">
              <UsersPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
      </Route>

      {/* Page 404 */}
      <Route path="/404" element={<NotFoundPage />} />

      {/* Redirection vers 404 pour les routes non définies */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRoutes;